<form [formGroup]="filterForm" class="filter-panel-form">
  <mat-accordion multi="true">

    <!-- Group 1: Species & Time -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Species & Dates</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="filter-cols">
        <!-- Fish Types -->
        <div class="filter-section">
          <h4>Fish Types</h4>
          
          <div *ngIf="showHeatmapToggle" class="checkbox-group">
            <label>
              <input type="checkbox" [checked]="heatMap" (change)="toggleHeatMap($event)">
              Heatmap
            </label>
          </div>

          <ng-container *ngIf="fishTypes.length > 0; else noTypes">
            <div formArrayName="selectedFishTypes" class="checkbox-group">
              <label *ngFor="let fishType of fishTypes">
                <input type="checkbox"
                       [value]="fishType.fish_name"
                       [checked]="filterForm.get('selectedFishTypes')?.value?.includes(fishType.fish_name)"
                       (change)="updateFishTypes(fishType.fish_name, $event)" />
                {{ fishType.fish_full_name }}
              </label>
            </div>
          </ng-container>
          <ng-template #noTypes><div class="loading-placeholder">Loading...</div></ng-template>
        </div>

        <!-- Date Range -->
        <div class="filter-section" formGroupName="dateRange">
          <h4>Date Range</h4>
          <div class="input-group">
            <label>Start: <input type="date" formControlName="start"></label>
            <label>End: <input type="date" formControlName="end"></label>
          </div>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- Group 2: Environmental Conditions -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Environmental Conditions</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="filter-cols">
        <!-- Temperature -->
        <div class="filter-section" formGroupName="temperature">
          <h4>Temperature (°F)</h4>
          <div class="input-group">
            <label>Min: <input type="number" formControlName="min" min="0" max="100"></label>
            <label>Max: <input type="number" formControlName="max" min="0" max="100"></label>
          </div>
        </div>

        <!-- Wind Speed -->
        <div class="filter-section" formGroupName="windSpeed">
          <h4>Wind Speed (mph)</h4>
          <div class="input-group">
            <label>Min: <input type="number" formControlName="min" min="0" max="100"></label>
            <label>Max: <input type="number" formControlName="max" min="0" max="100"></label>
          </div>
        </div>

        <!-- Wind Direction -->
        <div class="filter-section">
          <h4>Wind Direction</h4>
          <select formControlName="windDirection">
            <option value="">Any</option>
            <option *ngFor="let d of windDirections" [value]="d">{{ d }}</option>
          </select>
        </div>

        <!-- Weather Conditions -->
        <div class="filter-section">
          <h4>Weather Conditions</h4>
          <ng-container *ngIf="weatherConditions.length > 0; else noWeather">
            <div class="checkbox-group">
              <label *ngFor="let condition of weatherConditions">
                <input type="checkbox"
                       [checked]="filterForm.get('conditions')?.value?.includes(condition.short_forecast)"
                       (change)="updateConditions(condition.short_forecast, $event)" />
                {{ condition.short_forecast }}
              </label>
            </div>
          </ng-container>
          <ng-template #noWeather><div class="loading-placeholder">Loading...</div></ng-template>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- Group 3: Trip Details -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Trip Details</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="filter-cols">
        <!-- Tide -->
        <div class="filter-section">
          <h4>Tide</h4>
          <ng-container *ngIf="tideStates.length > 0; else noTides">
            <div class="checkbox-group">
              <label *ngFor="let tideState of tideStates">
                <input type="checkbox"
                       [checked]="filterForm.get('tide')?.value?.includes(tideState)"
                       (change)="updateTides(tideState, $event)" />
                {{ tideState }}
              </label>
            </div>
          </ng-container>
          <ng-template #noTides><div class="loading-placeholder">Loading...</div></ng-template>
        </div>

        <!-- Trip -->
        <div class="filter-section">
          <h4>Trip</h4>
          <select formControlName="trip_id">
            <option value="">Any</option>
            <option *ngFor="let trip of allFishingTrips" [value]="trip.trip_id">
              {{ trip.trip_id }} – {{ trip.start_time | date:'shortDate' }}
            </option>
          </select>
        </div>

        <!-- Angler Notes -->
        <div class="filter-section" *ngIf="showAnglerNotes">
          <h4>Angler Notes</h4>
          <select formControlName="anglerNotes">
            <option value="">All</option>
            <option value="yes">Has Notes</option>
            <option value="no">No Notes</option>
          </select>
        </div>
      </div>
    </mat-expansion-panel>

  </mat-accordion>
</form>
